var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"noty-list",attrs:{"name":"slide","tag":"div"}},_vm._l((_vm.notyList),function(item){return _c('Noty',{key:item.id,attrs:{"item":item},on:{"remove":_vm.onRemove}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }